export default {
    items: [
        {
            name: 'Заявки',
            url: '/agent/orders',
            icon: 'icon-bag'
        },
        {
            name: 'Путевки',
            url: '/agent/vouchers',
            icon: 'icon-briefcase'
        },
        {
            name: 'Заказчики',
            url: '/agent/customers',
            icon: 'icon-emotsmile',
            badge: {
                variant: 'info',
                text: 'скоро'
            },
        },
        {
            name: 'Подбор туров',    // НСБ › Агентство › Подбор туров
            url: '/agent/tourhelper',
            icon: 'icon-puzzle',
        },
        {
            name: 'Поиск',
            url: '/agent/search',
            icon: 'cui-magnifying-glass',
        },
        {
            name: 'Отчеты',
            url: '/agent/reports',
            icon: 'icon-book-open',
        },
        {
            name: 'Заезды',
            url: '/agent/checkins',
            icon: 'fa fa-taxi'
        },
    ]
}
